import { useEffect } from "react";
import { SessionLiveViewSection } from "src/components/admin/liveView/SessionLiveView";
import { usePageHeaderStore } from "src/store/pageHeaderStore";

export default function AdminLiveView() {
  const { setTitle, setActions, reset } = usePageHeaderStore();

  useEffect(() => {
    setTitle("Live View");
    setActions(
      <span className="bg-rfpurple-100 text-rfpurple-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
        Admin Portal
      </span>
    );
    return () => reset();
  }, [setTitle, setActions, reset]);

  return <SessionLiveViewSection />;
}
